import { IconType } from "@france/superelements/lib";
import { ProposalStates, SherpaProposalState } from "../../gql/hooks";

// Enum
export enum FileMimeType {
  PDF = "application/pdf",
  PPTX = "application/vnd.openxmlformats-officedocument.presentationml.presentation",
}

export enum categories {
  COMMERCIAL_CONDITIONS = "conditions",
  ASSORTMENT = "assortment",
}

// Type
export type ConditionType = {
  id: number;
  product: string;
  type: "Barri" | "Caja";
  rate: string;
  unitAmount: number;
  discountPerUnit: string;
  finalPricePerUnit: string;
  finalPricePerLiter: string;
  amortBonus: string;
};

export type ProposalStatusType = {
  value: ProposalStates | SherpaProposalState;
  icon: IconType;
  name: string;
};

/**
 * A negotiation whose PDF is already generated is downloaded and shared like
 * an accepted proposal: no live Sherpa check stands in the way.
 */
export const skipsSherpaGate = (
  state: ProposalStates | SherpaProposalState | null | undefined,
  pdf: { blobUrl?: string | null } | null | undefined,
) => state === SherpaProposalState.Negotiation && !!pdf?.blobUrl;

export const CONDITIONS_MOCK: ConditionType[] = [
  {
    id: 1,
    product: "Mahou Clasica-30L (#626)",
    type: "Barri",
    rate: "74,97€",
    unitAmount: 10,
    discountPerUnit: "14,00€/uc",
    finalPricePerUnit: "60,97€",
    finalPricePerLiter: "2,03/L€",
    amortBonus: "0,5€ Rappel/L",
  },
  {
    id: 2,
    product: "Mahou Clasica-30L (#626)",
    type: "Barri",
    rate: "74,97€",
    unitAmount: 10,
    discountPerUnit: "14,00€/uc",
    finalPricePerUnit: "60,97€",
    finalPricePerLiter: "2,03/L€",
    amortBonus: "0,5€ Rappel/L",
  },
  {
    id: 3,
    product: "Mahou Clasica-30L (#626)",
    type: "Barri",
    rate: "74,97€",
    unitAmount: 10,
    discountPerUnit: "14,00€/uc",
    finalPricePerUnit: "60,97€",
    finalPricePerLiter: "2,03/L€",
    amortBonus: "0,5€ Rappel/L",
  },
];
